export default __webpack_public_path__ + "static/media/65.7f205902.jpg";